import { Component, OnInit, Input, OnDestroy, ElementRef, HostListener, Inject, PLATFORM_ID, TransferState } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import { MktContentStorageService } from 'src/app/core/services/mkt-content-storage.service';
import { PowerReviewService } from '../../services/power-review.service';
import { Subscription } from 'rxjs';
import { MktSiteCatalystService } from 'src/app/core/services/mkt-site-catalyst.service';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import { MktDynamicOfferService, MktTaggingTransformationService } from 'src/app/core/services';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'ui-reviews-container',
  templateUrl: './reviews-container.component.html',
  styleUrls: ['./reviews-container.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ReviewsContainerComponent implements OnInit, OnDestroy {

  @Input() pid: string;
  @Input() hideDetailReview: boolean = true;
  private readonly MPP = 'Multi_Product_Page';
  private readonly BRANDING = 'Branding';
  private readonly COPY = 'copy';
  private readonly VAC = 'view-all-credit-cards';
  private readonly RRC = 'ratings-reviews-config';
  private readonly TEXT = 'TEXT';
  private powerReviewSub: Subscription = new Subscription();
  public cardDetail: any = null;
  public reviewFilters = [];
  public sortedReview = "Newest";
  public desktopScreen = true;
  private isBrowser:boolean=false;

  constructor(
    private mktContentStorageService: MktContentStorageService,
    private mktSiteCatalystService: MktSiteCatalystService,
    private _mktTagging:MktTaggingTransformationService,
    private mktDynamicOfferService:MktDynamicOfferService,
    private powerReview: PowerReviewService,
    private elementRef: ElementRef,
    private datePipe: DatePipe,
    private state: TransferState,
    @Inject(PLATFORM_ID) private platformId: string
  ) {
    this.reviewFilters.push({ value: "Newest", label: "Most Recent" });
    this.reviewFilters.push({ value: "LowestRating", label: "Lowest Rated" });
    this.reviewFilters.push({ value: "HighestRating", label: "Highest Rated" });
    this.reviewFilters.push({ value: "Oldest", label: "Oldest" });
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    if (this.isBrowser) {
      this.setClassOnResize();
      this.commonOnInit();
      this.initTagging('ccpageviewReviewOverlay')
      if (this.hideDetailReview) this.getRatingAndReviews();
    }
  }

  ngOnDestroy() {
    this.powerReviewSub.unsubscribe();
  }

  private commonOnInit() {
    const icmsContent = this.mktContentStorageService.get(this.MPP, this.COPY, this.VAC, undefined);
    const cardDetailsObj = icmsContent;
    const cardDetails = JSON.parse(cardDetailsObj[this.TEXT]);
    const { cardCategories } = cardDetails;
    const { prlegend, prdisclaimer } = this.mktContentStorageService.get(this.BRANDING, this.COPY, this.RRC, undefined);

    for (let i = 0; i < cardCategories.length; i++) {
      const { cardsList }: any = cardCategories[i];
      for (let j = 0; j < cardsList.length; j++) {
        const cardDetailsContent = this.mktContentStorageService.get(this.MPP, this.COPY, cardsList[j], undefined);
        const { PID, pidPT,cardName, learnMoreApplyLink, cardArtSpriteCss } = JSON.parse(cardDetailsContent[this.TEXT]);
        if(( pidPT || PID) !== this.pid) continue; // If different PID then continue until found same.
        const { cardDescription } = JSON.parse(cardDetailsContent[this.VAC]);
        this.cardDetail = { PID, cardName, learnMoreApplyLink, cardDescription, cardArtSpriteCss, prlegend, prdisclaimer };
        this.mktSiteCatalystService.callSC('ratingsAndReviewsClick', { 'ratingAndReviewDetail': this.cardDetail.cardName });
        break;// exit the loop as soon as found the correct PID
      }
    }
  }

  private getRatingAndReviews() {
    this.powerReviewSub.add(this.powerReview.callProductReview(this.pid).subscribe(async data => await this.handleServiceResponse(data)));
  }

  private handleServiceResponse({ results, paging }: any) {
    return new Promise(resolve => {
      if (!!results && results[0].reviews.length > 0) {
        // console.log("Reviews loaded successfully.", results[0].reviews);
        this.cardDetail.reviews = results[0].reviews.filter(({ details }) => details) || [];
        this.cardDetail.paging = paging;
        let page_size = this.cardDetail?.paging?.page_size;
        let current_page_number = this.cardDetail.paging.current_page_number;
        let total = (page_size * current_page_number);
        let previous_page_number = page_size * (current_page_number - 2);
        this.cardDetail.paging.previous_url = this.cardDetail.paging.next_page_url.replace(`paging.from=${total}`, `paging.from=${previous_page_number}`);
        this.cardDetail.paging.counter = ((total - page_size) + 1) + '-' + (total);
        this.cardDetail.reviews.map(review => {
          review.details.updated_date = this.getDays(review.details.updated_date);
        });
      }
      resolve(this.cardDetail);
    });
  }

  public callAnotherReviewPage(url: string) {
    this.powerReviewSub.add(this.powerReview.callAnotherPage(url).subscribe(async data => {
      await this.handleServiceResponse(data);
      this.backToTop();
    }));
  }

  public callSortedReviewPage(event) {
    this.sortedReview = event.currentTarget.value;
    this.initTagging('ccpageviewReviewOverlaySort');
    this.powerReviewSub.add(this.powerReview.callSortedPage(this.sortedReview).subscribe(async data => {
      await this.handleServiceResponse(data);
    }));
  }

  private initTagging(type){
    const prospect_id = this.mktDynamicOfferService.generateProspectId();
    const products = [];
    products.push({
      pid: this.pid
    });
    this._mktTagging.tagMktCompareCards(type, { prospect_id: prospect_id, pid: this.pid, products: products });
  }

  public handleReviewClick() {
    console.log('Modal Review Count Clicked');
  }

  public backToTop() {
    const closeIconRef = document.querySelector('.modal-close-button');
    !!closeIconRef && closeIconRef.scrollIntoView(true);
    const instance = setTimeout(() => {
      const reviewHeadingRef = this.elementRef.nativeElement.querySelector('h3.review-0');
      reviewHeadingRef.focus();
      clearTimeout(instance);
    }, 500);
  }

  public getDays(submissionDate): string {
    const todaysDate = new Date();
    const date1 = new Date(todaysDate);
    const pastDate = this.datePipe.transform(submissionDate, "yyyy-MM-dd");
    const date2 = new Date(pastDate);
    let difference = date1.getTime() - date2.getTime();
    let time = difference / 1000;
    let year = Math.abs(Math.round(time / (60 * 60 * 24) / 365.25));
    let month = Math.abs(Math.round(time / (60 * 60 * 24 * 7 * 4)));
    let days = Math.abs(Math.round(time / (3600 * 24)));

    if (year) {
      return  `${year} ${(year > 1) ? " years ago" : " year ago"}`;
    } else {
      if (month) {
        return  `${month} ${(month > 1) ? " months ago" : " month ago"}`;
      } else {
        return  `${days} ${(days > 1) ? " days ago" : " day ago"}`;
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  setClassOnResize() {
      this.desktopScreen = (window.innerWidth > 1073);
  }
}
